export default {
  methods: {
    calcResourceCost(res) {
      let hrs = parseFloat(res.hrs);
      let per = parseFloat(res.per);
      let rate = parseFloat(res.rate);
      let cost = hrs * per * rate;
      cost = cost.toFixed(2);
      if (isNaN(cost)) {
        cost = "Define Cost";
      } else {
        cost = "$" + cost.toString();
      }
      return cost;
    },
    calcResourceCostOnly(res) {
      let hrs = parseFloat(res.hrs);
      let per = parseFloat(res.per);
      let rate = parseFloat(res.rate);
      let cost = hrs * per * rate;
      if (isNaN(cost)) {
        cost = "Define Cost";
      } else {
        cost = cost.toString();
      }
      return cost;
    },
    calcResourcePersonHours(res) {
      let hrs = parseFloat(res.hrs);
      let per = parseFloat(res.per);
      let ph = per * hrs;
      if (isNaN(ph)) {
        ph = "Define Hrs";
      } else {
        ph = ph.toString() + "ph";
      }
      return ph;
    },
    calcPartCost(res) {
      let cost = parseFloat(res.cost);
      let qty = parseFloat(res.qty);
      cost = cost.toFixed(2);
      if (isNaN(cost) || isNaN(qty)) {
        cost = "Define Cost";
      } else {
        cost = cost * qty;
        cost = cost.toFixed(2);
        cost = "$" + cost.toString();
      }
      return cost;
    },
    calcPartCarbon(res) {
      let car = parseFloat(res.carb);
      let qty = parseFloat(res.qty);
      car = car.toFixed(2);
      if (isNaN(car) || isNaN(qty)) {
        car = "Define Cost";
      } else {
        car = car * qty;
        car = car.toFixed(2);
        car = car.toString() + "kg";
      }
      return car;
    },
    calcMaterialOrderCarbon(carb, qty) {
      let car = parseFloat(carb);
      let q = parseFloat(qty);
      car = car.toFixed(2);
      if (isNaN(car) || isNaN(qty)) {
        car = "Define Cost";
      } else {
        car = car * q;
        car = car.toFixed(2);
        car = car.toString() + "kg";
      }
      return car;
    },
    calcMaterialOrderCost(cost, qty) {
      let cos = parseFloat(cost);
      let q = parseFloat(qty);
      cos = cos.toFixed(2);
      if (isNaN(cos) || isNaN(qty)) {
        cos = "Define Cost";
      } else {
        cos = cos * q;
        cos = cos.toFixed(2);
        cos = "$" + cos.toString();
      }
      return cos;
    },
    calcMaterialOrderCostOnly(cost, qty) {
      let cos = parseFloat(cost);
      let q = parseFloat(qty);
      cos = cos.toFixed(2);
      if (isNaN(cos) || isNaN(qty)) {
        cos = "Define Cost";
      } else {
        cos = cos * q;
        cos = cos.toString();
      }
      return cos;
    },
    calcResourcesListHours(type, resList, na1) {
      let ph = 0;
      for (var i = 0; i < resList.length; i++) {
        if (type === resList[i].char.type || type === "ALL") {
          // eslint-disable-next-line
          ph = ph + parseFloat(resList[i].char.hrs)*parseInt(resList[i].char.per);
        }
      }
      ph = na1 * ph;
      ph = ph.toFixed(1);
      if (isNaN(ph)) {
        ph = "0";
      } else {
        ph.toString();
      }
      return ph + "ph";
    },
    calcTasksListHoursEstimate(type, tasksList) {
      let ph = 0;
      for (var i = 0; i < tasksList.length; i++) {
        if (type === tasksList[i].char.type || type === "ALL") {
          // eslint-disable-next-line
          ph = ph + parseInt(tasksList[i].char.hrs)*parseInt(tasksList[i].char.per);
        }
      }
      return ph.toString() + "ph";
    },
    calcTasksListHoursActual(type, tasksList) {
      let ph = 0;
      for (var i = 0; i < tasksList.length; i++) {
        if (type === tasksList[i].char.type || type === "ALL") {
          // eslint-disable-next-line
          ph = ph + parseInt(tasksList[i].char.hrsa)*parseInt(tasksList[i].char.per);
        }
      }
      return ph.toString() + "ph";
    },
    calcResourcesListCost(type, partsList, na1) {
      let cost = 0;
      let hrs = 0;
      let per = 0;
      let rate = 0;
      for (var i = 0; i < partsList.length; i++) {
        hrs = parseFloat(partsList[i].char.hrs);
        per = parseFloat(partsList[i].char.per);
        rate = parseFloat(partsList[i].char.rate);
        if (type === partsList[i].char.type || type === "ALL") {
          cost = cost + hrs * per * rate;
        }
      }
      cost = cost * na1;
      cost = cost.toFixed(2);
      if (isNaN(cost)) {
        cost = "NA";
      } else {
        cost = "$" + cost.toString();
      }
      return cost;
    },
    calcPartsListQty(type, partsList, na1) {
      let qty = 0;
      for (var i = 0; i < partsList.length; i++) {
        if (type === partsList[i].char.type || type === "ALL") {
          qty = qty + parseInt(partsList[i].char.qty);
        }
      }
      qty = qty * na1;
      if (isNaN(qty)) {
        qty = "NA";
      } else {
        qty = qty.toString() + "qty";
      }
      return qty;
    },
    calcPartsListCost(type, partsList, na1) {
      let cost = 0;
      let qty = 0;
      let itemCost = 0;
      for (var i = 0; i < partsList.length; i++) {
        itemCost = parseFloat(partsList[i].char.cost);
        qty = parseInt(partsList[i].char.qty);
        if (type === partsList[i].char.type || type === "ALL") {
          cost = cost + itemCost * qty;
        }
      }
      cost = cost * na1;
      cost = cost.toFixed(2);
      if (isNaN(cost)) {
        cost = "NA";
      } else {
        cost = "$" + cost.toString();
      }
      // cost = cost.toFixed(2);
      return cost;
    },
    calcPartsListCarbon(partsList, na1) {
      let carbon = 0;
      for (var i = 0; i < partsList.length; i++) {
        // eslint-disable-next-line
        carbon = carbon + parseFloat(partsList[i].char.carb) * parseFloat(partsList[i].char.qty);
      }
      carbon = carbon * na1;
      if (isNaN(carbon)) {
        carbon = "No Carbon";
      } else {
        carbon = carbon.toFixed(1);
        carbon = carbon.toString() + "kg";
      }
      return carbon;
    },
    calcTotalEstimateCost(resList, partsList, na1) {
      let cost = 0;
      let costRes = 0;
      let costParts = 0;
      let costPartsItem = 0;
      let hrs = 0;
      let per = 0;
      let rate = 0;
      let qty = 0;
      for (var i = 0; i < resList.length; i++) {
        hrs = parseFloat(resList[i].char.hrs);
        per = parseFloat(resList[i].char.per);
        rate = parseFloat(resList[i].char.rate);
        costRes = costRes + hrs * per * rate;
      }
      for (var j = 0; j < partsList.length; j++) {
        costPartsItem = parseFloat(partsList[j].char.cost);
        qty = parseFloat(partsList[j].char.qty);
        costParts = costParts + costPartsItem * qty;
      }
      cost = costRes + costParts;
      cost = cost * na1;
      cost = cost.toFixed(2);
      if (isNaN(cost)) {
        cost = "No Cost";
      } else {
        cost = "$" + cost.toString();
      }
      return cost;
    },
    calcCarbon(item) {
      let carbon = 0;
      if (item !== "" && !isNaN(item)) {
        carbon = carbon.pareInt();
        carbon = carbon.toFixed(1);
      }
      return carbon.toString() + "kg";
    },
    calcCost(item, logic, qty) {
      console.log("");
      console.log("CALC COST");
      console.log(item);
      console.log(logic);
      let cost = 0;
      let q = parseFloat(qty);
      if (item !== "" && !isNaN(item)) {
        cost = parseFloat(item) * q;
      }
      // cost = cost.toFixed(2);
      if (logic === "()") {
        cost = "$(" + cost.toString() + ")";
      } else {
        // cost = cost.toFixed(1);
        cost = "$" + cost.toString();
      }
      return cost;
    },
    calcTotalOrderCost(item) {
      let cost = 0;
      let costo = item.costo;
      let costt = item.costt;
      let paya = item.paya;
      let qty = item.qty;
      if (isNaN(costo) || costo == "") {
        costo = 0;
      }
      if (isNaN(costt) || costt == "") {
        costt = 0;
      }
      if (isNaN(paya) || paya == "") {
        paya = 0;
      }
      // eslint-disable-next-line
      cost = parseFloat(qty)*parseFloat(costo) + parseFloat(costt) + parseFloat(paya);
      cost = cost.toFixed(2);
      return "$" + cost.toString();
    },
    calcRemainingCost(item) {
      let rem = 0;
      let costo = item.costo;
      let costt = item.costt;
      let payd = item.payd;
      let paya = item.paya;
      let qty = item.qty;
      if (isNaN(costo) || costo == "") {
        costo = 0;
      }
      if (isNaN(costt) || costt == "") {
        costt = 0;
      }
      if (isNaN(payd) || payd == "") {
        payd = 0;
      }
      if (isNaN(paya) || paya == "") {
        paya = 0;
      }
      // eslint-disable-next-line
      rem = parseFloat(qty)*parseFloat(costo) + parseFloat(costt) - parseFloat(payd) + parseFloat(paya);
      rem = rem.toFixed(2);
      return "$" + rem.toString();
    },
    calcTotalOrderCarbon(item) {
      let carbon = 0;
      let carbo = item.carbo;
      let carbt = item.carbt;
      let qty = item.qty;
      if (isNaN(carbo) || carbo == "") {
        carbo = 0;
      }
      if (isNaN(carbt) || carbt == "") {
        carbt = 0;
      }
      // eslint-disable-next-line
      carbon = parseInt(qty)*parseInt(carbo) + parseInt(carbt);
      return carbon.toString() + "kg";
    },
    calcGrantTotalAllOrdersCarbon(orders) {
      let carbon = 0;
      let carbo = 0;
      let carbt = 0;
      let qty = 0;

      for (var i = 0; i < orders.length; i++) {
        carbo = orders[i].char.carbo;
        carbt = orders[i].char.carbt;
        qty = orders[i].char.qty;
        // CONVERT to NUM
        if (isNaN(carbo) || carbo == "") {
          carbo = 0;
        }
        if (isNaN(carbt) || carbt == "") {
          carbt = 0;
        }
        // ITEM
        // CONVERT COST TO FLOAT
        carbo = parseFloat(carbo);
        carbt = parseFloat(carbt);
        qty = parseFloat(qty);
        // ADD TOTAL CARBON
        carbon = carbon + carbo * qty + carbt;
      }
      carbon = parseFloat(carbon).toFixed(1);
      // eslint-disable-next-line
      return carbon.toString() + " kg";
    },
    calcGrantTotalAllOrdersCost(orders) {
      let cost = 0;
      let costo = 0;
      let costt = 0;
      let qty = 0;

      for (var i = 0; i < orders.length; i++) {
        costo = orders[i].char.costo;
        costt = orders[i].char.costt;
        qty = orders[i].char.qty;
        // CONVERT to NUM
        if (isNaN(costo) || costo == "") {
          costo = 0;
        }
        if (isNaN(costt) || costt == "") {
          costt = 0;
        }
        // CONVERT COST TO FLOAT
        costo = parseFloat(costo);
        costt = parseFloat(costt);
        qty = parseFloat(qty);
        // ADD TOTAL CARBON
        cost = cost + costo * qty + costt;
      }
      cost = parseFloat(cost).toFixed(2);
      // eslint-disable-next-line
      return "AUD " + cost.toString();
    }
  }
};
